// extracted by mini-css-extract-plugin
export default {"container":"chatIntegration_container__7fge6"};